{
  "SectionHint": "È possibile specificare individualmente il codice del motivo di indisponibilità ACD utilizzato per calcolare ciascuna delle 10 diverse varianti statistiche del tempo totale e medio di indisponibilità ACD. Selezionare i 10 codici sottostanti per i quali le statistiche del tempo di stato ACD saranno misurate individualmente:",
  "NaCode01Label": "Non disponibile Codice 01:",
  "NaCode02Label": "Non disponibile Codice 02:",
  "NaCode03Label": "Non disponibile Codice 03:",
  "NaCode04Label": "Non disponibile Codice 04:",
  "NaCode05Label": "Non disponibile Codice 05:",
  "NaCode06Label": "Non disponibile Codice 06:",
  "NaCode07Label": "Non disponibile Codice 07:",
  "NaCode08Label": "Non disponibile Codice 08:",
  "NaCode09Label": "Non disponibile Codice 09:",
  "NaCode10Label": "Non disponibile Codice 10:",
  "UseCodeDescriptionLabel": "Utilizzare la descrizione del codice nelle statistiche relative ai codici ACD N-A",
  "ResetCodesHeader": "Codici di reset",
  "ResetCodesHint": "Se nell'ambiente di telefonia sono stati configurati codici di motivo ACD Non disponibile e i primi 10 di questi sono diversi dai valori di impostazione correnti mostrati sopra, è possibile fare clic sul pulsante seguente per impostare i valori di default utilizzando i primi dieci codici rilevati.",
  "ResetCodesButtonText": "Codici di reset",
  "ResetCodesConfirmDialogHint": "Si è sicuri di voler reimpostare tutte le impostazioni delle statistiche dei codici motivo ACD non disponibili sui primi 10 codici attualmente configurati nell'ambiente di telefonia?",
  "ACDCodesLanguage_SectionHeader": "Varianti della statistica del tempo non disponibile ACD",
  "NAME": "ACDCodesLanguage",
  "NaCode11Label": "Codice non disponibile 11:"
}